import { css } from '@tanium/react-emotion';

export const hideDatepickerAriaAnnouncementStyles = css({
  // Visually hide a11y announcement.
  // https://github.com/Hacker0x01/react-datepicker/pull/3817/files#diff-c1303e6357ee02a3241e628862f37cc40d4835cbb65c69bfd1a09f83ad4ffe35R693
  '.react-datepicker__aria-live': {
    position: 'absolute',
    clipPath: 'circle(0)',
    border: '0',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    width: '1px',
    whiteSpace: 'nowrap',
  },
});
